import dynamic from "next/dynamic";

export const DynamicHeaderAvatar = dynamic(() =>
  import("./header-avatar").then(module => module.HeaderAvatar),
);
